import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";

export default class MissingAttributesException extends Error {
    constructor(minRequired: number, ...attributes: string[]) {
        const message = `Missing attributes! Expected to have at least ${minRequired} of the following attributes: [${attributes.join(", ")}]`;

        super(message);

        DiagnosticsStore.collectEventLog("error", message);
    }
}
